import {Box, Grid} from '@mui/material';
import Button from 'components/UI/Button';
import LoadingButton from 'components/UI/LoadingButton';
import InputField from 'components/UI/form/InputField';
import {ROUTES} from 'constants/routes';
import {Form, Formik} from 'formik';
import useTranslate from 'hooks/useTranslate';
import {HttpError} from 'models/http-interface';
import {BaitBoxTagForm} from 'models/tags-interface';
import {useNavigate} from 'react-router';
import {useAppDispatch, useAppSelector} from 'redux/redux';
import {getBaitBoxTagsState} from 'redux/tags/selector';
import {createBaitBoxTagAsync} from 'redux/tags/thunk';
import {formatError} from 'utils/http-error-formatter';
import {showError, showSuccess} from 'utils/toast-alerts';
import {AddBaitBoxTagSchema} from 'utils/validation-schema';

const addBaitBoxTagFields = [{name: 'name', label: 'NAME', type: 'text'}];

const AddBaitBoxTag = () => {
  const {parseUI} = useTranslate();
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const {loading} = useAppSelector(getBaitBoxTagsState);

  const initialValues: BaitBoxTagForm = {
    name: '',
  };

  const handleSubmit = async (formData: BaitBoxTagForm) => {
    try {
      const response = await dispatch(createBaitBoxTagAsync(formData)).unwrap();
      showSuccess(response.message);
      navigate(`/${ROUTES.DASHBOARD}/${ROUTES.LIST_TAGS}`);
    } catch (error) {
      const errorMsg = formatError((error as HttpError).error);
      showError(errorMsg);
    }
  };

  const onCancelClick = () => {
    navigate(`/${ROUTES.DASHBOARD}/${ROUTES.LIST_TAGS}`);
  };

  return (
    <Box display="flex" flexDirection="column" alignItems="center" justifyContent="center" className="plr36">
      <h1 className="page-title">{parseUI('ADD_TAG')}</h1>
      <Formik
        initialValues={initialValues}
        validationSchema={AddBaitBoxTagSchema}
        onSubmit={handleSubmit}
        validateOnBlur={true}
        validateOnChange={true}>
        {({isValid, dirty}) => (
          <Form style={{width: '50%'}}>
            <Grid container spacing={2}>
              {addBaitBoxTagFields?.map(field => (
                <div key={field.name} style={{width: '100%'}}>
                  <InputField name={field.name} type={field.type} label={field.label} />
                </div>
              ))}
            </Grid>

            <Box justifyContent={'space-between'} alignItems={'justify-end'}>
              <div className="btn-end">
                <LoadingButton
                  type="submit"
                  label="SUBMIT"
                  loader={loading}
                  className="loading-button"
                  disabled={!isValid || !dirty || loading}
                />

                <Button type="button" onClick={onCancelClick} label="CANCEL" />
              </div>
            </Box>
          </Form>
        )}
      </Formik>
    </Box>
  );
};

export default AddBaitBoxTag;
